import { Component } from '@angular/core';

@Component({
  selector: 'app-settings-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.css']
})
export class SecuritySettingsComponent {
  enable2FA = false;

  toggle2FA() {
    this.enable2FA = !this.enable2FA;
    console.log('2FA status:', this.enable2FA);
    // Add logic to update 2FA setting
  }
}
